import * as React from 'react';

import { Formik, Field } from 'formik';
import { Box, Grid } from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight, faAddressBook } from '@fortawesome/free-solid-svg-icons';

import * as Yup from 'yup';
import throttle from 'lodash/throttle';

import {
	CerebroLabel,
	CerebroHeading,
	CerebroText,
	CerebroPrimaryButton,
	CerebroSecondaryButton,
	CerebroIcon,
	CerebroInput,
	CerebroDropdown,
	CerebroDropdownMenuItem,
	CerebroMultiDropdown,
	CerebroMultiDropdownMenuItem,
	CerebroDatePicker,
	CerebroCheckbox,
	CerebroPill,
	CerebroSelectableIcon,
	CerebroFileDragAndDrop,
	CerebroComplexListItem,
	CerebroBrokenBox,
	CerebroDrawer,
	CerebroYesNo,
	IconRadioGroup,
	IconRadioButton,
	IconMultiSelect,
	IconMultiSelectOption,
	CerebroMaskedInput,
	CerebroTextarea,
	CerebroAutoComplete,
	CerebroAutoCompleteProps,
} from '../shared/components';
import { useApi, useAuth, useCerebroNav } from '../shared/context';
import { useEnvironment, useStatesQuery } from '../shared/hooks';

import { ReactComponent as DebtScheduleIcon } from '../shared/icons/DebtScheduleIcon.svg';
import { useSnackbar } from 'notistack';
import { State } from '../shared/models';
import { AxiosUtils } from '../shared/utils';
import { useQuery } from 'react-query';
import { CerebroApiEndpoints } from '../shared/utils/api';

export const HelloWorld: React.FC = () => {
	const auth = useAuth();
	const { navItems } = useCerebroNav();

	const environment = useEnvironment();
	const { enqueueSnackbar } = useSnackbar();

	const [pillSelected, setPillSelected] = React.useState(true);

	const [open, setOpen] = React.useState(false);

	const statesQuery = useStatesQuery('', { enabled: open });

	return (
		<Box sx={{ padding: 2 }}>
			<CerebroHeading>Hello World!</CerebroHeading>

			<br />

			<CerebroText>Environment: {environment}</CerebroText>
			<CerebroText>API Root Url: {process.env.REACT_APP_CEREBRO_API_ROOT_URL}</CerebroText>

			<br />

			<CerebroLabel htmlFor="">Auth State:</CerebroLabel>
			<pre style={{ padding: '8px', backgroundColor: 'whitesmoke' }}>
				<code>{JSON.stringify(auth, null, 4)}</code>
			</pre>

			<CerebroPrimaryButton onClick={() => setOpen(true)}>Open Drawer</CerebroPrimaryButton>

			<br />
			<br />

			<CerebroSecondaryButton
				onClick={() => enqueueSnackbar('This is a success snackbar', { variant: 'success' })}
				sx={{ marginRight: 2 }}
			>
				Show Success Snackbar
			</CerebroSecondaryButton>

			<CerebroSecondaryButton
				onClick={() => enqueueSnackbar('This is an info snackbar', { variant: 'info' })}
				sx={{ marginRight: 2 }}
			>
				Show Info Snackbar
			</CerebroSecondaryButton>

			<CerebroSecondaryButton
				onClick={() => enqueueSnackbar('This is an error snackbar', { variant: 'error' })}
				sx={{ marginRight: 2 }}
			>
				Show Error Snackbar
			</CerebroSecondaryButton>

			<br />
			<br />
			<br />
			<br />
			<br />

			<Formik
				initialValues={{
					iconRadioGroup: null,
					iconMultiSelect: [],
				}}
				validationSchema={Yup.object().shape({
					iconRadioGroup: Yup.string()
						.nullable(true)
						.required('You must select on of the options in the iconRadioGroup'),

					iconMultiSelect: Yup.array()
						.of(Yup.string())
						.min(1, 'You must select at least one option of the icon multi select.'),
				})}
				onSubmit={values => console.table(values)}
			>
				{({ errors, touched, handleSubmit, values }) => {
					return (
						<form onSubmit={handleSubmit}>
							<CerebroLabel htmlFor="iconRadioGroup" sx={{ marginBottom: 2 }}>
								Icon Radio Group:{' '}
								<CerebroText variant="hint" sx={{ marginTop: 0.25 }}>
									Current Value: {values.iconRadioGroup}
								</CerebroText>
							</CerebroLabel>
							<Field
								sx={{ marginY: 2 }}
								as={IconRadioGroup}
								name="iconRadioGroup"
								error={touched.iconRadioGroup && errors.iconRadioGroup}
							>
								<Grid container spacing={2}>
									<Grid item>
										<IconRadioButton
											value="1st Value"
											icon={() => <FontAwesomeIcon icon={faAddressBook} size="3x" />}
										>
											1st Value
										</IconRadioButton>
									</Grid>
									<Grid item>
										<IconRadioButton
											value="2nd Value"
											icon={() => <FontAwesomeIcon icon={faAddressBook} size="3x" />}
										>
											2nd Value
										</IconRadioButton>
									</Grid>
									<Grid item>
										<IconRadioButton
											value="3rd Value"
											icon={() => <FontAwesomeIcon icon={faAddressBook} size="3x" />}
										>
											3rd Value
										</IconRadioButton>
									</Grid>
									<Grid item>
										<IconRadioButton
											value="4th Value"
											icon={() => <FontAwesomeIcon icon={faAddressBook} size="3x" />}
										>
											4th Value
										</IconRadioButton>
									</Grid>
								</Grid>
							</Field>
							{touched.iconRadioGroup && errors.iconRadioGroup && (
								<CerebroText variant="error" sx={{ marginBottom: 2 }}>
									{errors.iconRadioGroup}
								</CerebroText>
							)}

							<CerebroLabel htmlFor="iconMultiSelect" sx={{ marginBottom: 2 }}>
								Icon Multi Select:{' '}
								{values.iconMultiSelect && (
									<CerebroText variant="hint" sx={{ marginTop: 0.25 }}>
										Current Value: {values.iconMultiSelect.join(', ')}
									</CerebroText>
								)}
							</CerebroLabel>
							<Field
								sx={{ marginY: 2 }}
								as={IconMultiSelect}
								name="iconMultiSelect"
								error={touched.iconMultiSelect && errors.iconMultiSelect}
							>
								<Grid container spacing={2}>
									<Grid item>
										<IconMultiSelectOption
											value="1st Value"
											icon={() => <FontAwesomeIcon icon={faAddressBook} size="3x" />}
										>
											1st Value
										</IconMultiSelectOption>
									</Grid>
									<Grid item>
										<IconMultiSelectOption
											value="2nd Value"
											icon={() => <FontAwesomeIcon icon={faAddressBook} size="3x" />}
										>
											2nd Value
										</IconMultiSelectOption>
									</Grid>
									<Grid item>
										<IconMultiSelectOption
											value="3rd Value"
											icon={() => <FontAwesomeIcon icon={faAddressBook} size="3x" />}
										>
											3rd Value
										</IconMultiSelectOption>
									</Grid>
									<Grid item>
										<IconMultiSelectOption
											value="4th Value"
											icon={() => <FontAwesomeIcon icon={faAddressBook} size="3x" />}
										>
											4th Value
										</IconMultiSelectOption>
									</Grid>
								</Grid>
							</Field>
							{touched.iconMultiSelect && errors.iconMultiSelect && (
								<CerebroText variant="error" sx={{ marginBottom: 2 }}>
									{errors.iconMultiSelect}
								</CerebroText>
							)}
							<CerebroPrimaryButton type="submit">Save &amp; Continue</CerebroPrimaryButton>
						</form>
					);
				}}
			</Formik>

			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />

			<CerebroDrawer open={open} onClose={() => setOpen(false)} icon={DebtScheduleIcon}>
				<CerebroPrimaryButton sx={{ display: 'block' }}>
					Save &amp; Continue
					<CerebroIcon padLeft>
						<FontAwesomeIcon icon={faLongArrowAltRight} />
					</CerebroIcon>
				</CerebroPrimaryButton>

				<br />

				<CerebroSecondaryButton sx={{ display: 'block' }}>Save &amp; Continue</CerebroSecondaryButton>

				<br />

				<CerebroHeading size="h1">H1</CerebroHeading>
				<CerebroHeading size="h2">H2</CerebroHeading>
				<CerebroHeading size="h3">H3</CerebroHeading>

				<br />

				<CerebroText>Body Large</CerebroText>
				<CerebroText variant="small">Body Small</CerebroText>

				<br />
				<CerebroText variant="data">Data / Numbers</CerebroText>

				<br />

				<CerebroLabel htmlFor="Foo">Label Large</CerebroLabel>
				<CerebroLabel size="small" htmlFor="Foo">
					Label Small
				</CerebroLabel>

				<br />

				<Formik
					enableReinitialize
					initialValues={{
						stateAutoComplete: [{ code: 'SC        ', name: 'South Carolina' }],
						stateAutoCompleteOnType: [{ code: 'SC        ', name: 'South Carolina' }],
						input1: '',
						input2: 'Input Value',
						input3: 'Input Value',
						input4: '',
						dropdown: -1,
						dropdown2: '10',
						dropdown3: '20',
						multi: ['SC'],
						multi2: ['GA'],
						multi3: ['FL'],
						date: new Date(1996, 5, 4),
						date2: new Date(1996, 5, 4),
						date3: new Date(1996, 5, 4),
						toggle: true,
						yesNo: null,
						iconSelected: false,
						wideIconSelected: false,
						documents: [],
						iconRadioGroup: null,
						textarea: 'textarea field',
					}}
					validationSchema={ValidationSchema}
					onSubmit={() => {}}
				>
					{({ errors, touched, handleSubmit, values }) => {
						return (
							<form onSubmit={handleSubmit} encType="multipart/form-data">
								<Box sx={{ marginY: 3 }}>
									<CerebroLabel
										required
										htmlFor="stateAutoComplete"
										error={touched.stateAutoComplete && errors.stateAutoComplete != null}
									>
										State Auto-Complete
									</CerebroLabel>
									<Field
										multiple
										clearOnEscape
										component={CerebroAutoComplete}
										loading={statesQuery.isLoading}
										id="stateAutoComplete"
										name="stateAutoComplete"
										placeholder="Pick a state"
										options={statesQuery.data ?? []}
										isOptionEqualToValue={(option: State, value: State) =>
											option.code === value.code
										}
										getOptionLabel={(state: State) => state.name}
										error={touched.stateAutoComplete && errors.stateAutoComplete != null}
									/>
									{touched.stateAutoComplete && errors.stateAutoComplete != null && (
										<CerebroText variant="error">{errors.stateAutoComplete}</CerebroText>
									)}
								</Box>

								<Box sx={{ marginY: 3 }}>
									<CerebroLabel
										required
										htmlFor="stateAutoCompleteOnType"
										error={
											touched.stateAutoCompleteOnType && errors.stateAutoCompleteOnType != null
										}
									>
										State Auto-Complete (Search as you type)
									</CerebroLabel>
									<Field
										component={StateAutoCompleteOnType}
										id="stateAutoCompleteOnType"
										name="stateAutoCompleteOnType"
										placeholder="Pick a state"
										error={
											touched.stateAutoCompleteOnType && errors.stateAutoCompleteOnType != null
										}
									/>
									{touched.stateAutoCompleteOnType && errors.stateAutoCompleteOnType != null && (
										<CerebroText variant="error">{errors.stateAutoCompleteOnType}</CerebroText>
									)}
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel
										required
										htmlFor="input1"
										error={touched.input1 && errors.input1 != null}
									>
										What percentage of the business is being purchased from the seller?
									</CerebroLabel>
									<Field
										as={CerebroInput}
										id="input1"
										name="input1"
										placeholder="Hint Text"
										error={touched.input1 && errors.input1 != null}
									/>
									{touched.input1 && errors.input1 != null && (
										<CerebroText variant="error">{errors.input1}</CerebroText>
									)}
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel
										required
										htmlFor="input4"
										error={touched.input4 && errors.input4 != null}
									>
										Input 4
									</CerebroLabel>
									<Field
										as={CerebroInput}
										id="input4"
										name="input4"
										placeholder="Hint Text"
										error={touched.input4 && errors.input4 != null}
									/>
									{touched.input4 && errors.input4 != null && (
										<CerebroText variant="error">{errors.input4}</CerebroText>
									)}
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="input2">Input (Disabled)</CerebroLabel>
									<Field as={CerebroInput} id="input2" name="input2" disabled />
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="input3">Input (Read-Only)</CerebroLabel>
									<Field as={CerebroInput} id="input3" name="input3" readOnly />
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel
										required
										htmlFor="dropdown"
										error={errors.dropdown !== undefined && touched.dropdown}
									>
										Dropdown
									</CerebroLabel>

									<Field
										as={CerebroDropdown}
										id="dropdown"
										name="dropdown"
										error={errors.dropdown !== undefined && touched.dropdown}
									>
										<CerebroDropdownMenuItem value={-1}>Select a Value</CerebroDropdownMenuItem>
										<CerebroDropdownMenuItem value="Zero">Zero</CerebroDropdownMenuItem>
										<CerebroDropdownMenuItem value="Ten">Ten</CerebroDropdownMenuItem>
										<CerebroDropdownMenuItem value="Twenty">Twenty</CerebroDropdownMenuItem>
									</Field>

									{touched.dropdown && errors.dropdown != null && (
										<CerebroText variant="error">{errors.dropdown}</CerebroText>
									)}
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="dropdown2">Dropdown (Disabled)</CerebroLabel>
									<Field as={CerebroDropdown} id="dropdown2" name="dropdown2" disabled>
										<CerebroDropdownMenuItem value={0}>Zero</CerebroDropdownMenuItem>
										<CerebroDropdownMenuItem value={10}>Ten</CerebroDropdownMenuItem>
										<CerebroDropdownMenuItem value={20}>Twenty</CerebroDropdownMenuItem>
									</Field>
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="dropdown3">Dropdown (Read-Only)</CerebroLabel>
									<Field as={CerebroDropdown} id="dropdown3" name="dropdown3" readOnly>
										<CerebroDropdownMenuItem value={0}>Zero</CerebroDropdownMenuItem>
										<CerebroDropdownMenuItem value={10}>Ten</CerebroDropdownMenuItem>
										<CerebroDropdownMenuItem value={20}>Twenty</CerebroDropdownMenuItem>
									</Field>
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="multi" error={errors.multi !== undefined && touched.multi}>
										Multi-Dropdown
									</CerebroLabel>
									<Field
										as={CerebroMultiDropdown}
										id="multi"
										name="multi"
										placeholder="Select one or more values"
										error={errors.multi !== undefined && touched.multi}
									>
										<CerebroMultiDropdownMenuItem value="SC">
											South Carolina
										</CerebroMultiDropdownMenuItem>
										<CerebroMultiDropdownMenuItem value="GA">Georgia</CerebroMultiDropdownMenuItem>
										<CerebroMultiDropdownMenuItem value="FL">Florida</CerebroMultiDropdownMenuItem>
									</Field>

									{touched.multi && errors.multi != null && (
										<CerebroText variant="error">{errors.multi}</CerebroText>
									)}
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="multi2">Multi-Dropdown (Disabled)</CerebroLabel>
									<Field as={CerebroMultiDropdown} id="multi2" name="multi2" disabled>
										<CerebroMultiDropdownMenuItem value="SC">
											South Carolina
										</CerebroMultiDropdownMenuItem>
										<CerebroMultiDropdownMenuItem value="GA">Georgia</CerebroMultiDropdownMenuItem>
										<CerebroMultiDropdownMenuItem value="FL">Florida</CerebroMultiDropdownMenuItem>
									</Field>
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="multi3">Multi-Dropdown (Read-Only)</CerebroLabel>
									<Field as={CerebroMultiDropdown} id="multi3" name="multi3" readOnly>
										<CerebroMultiDropdownMenuItem value="SC">
											South Carolina
										</CerebroMultiDropdownMenuItem>
										<CerebroMultiDropdownMenuItem value="GA">Georgia</CerebroMultiDropdownMenuItem>
										<CerebroMultiDropdownMenuItem value="FL">Florida</CerebroMultiDropdownMenuItem>
									</Field>
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="date">Date Picker</CerebroLabel>
									<Field
										component={CerebroDatePicker}
										id="date"
										name="date"
										error={errors.date !== undefined && touched.date}
									/>
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="date2">Date Picker (Disabled)</CerebroLabel>
									<Field component={CerebroDatePicker} id="date2" name="date2" disabled />
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="date2">Date Picker (Read-Only)</CerebroLabel>
									<Field component={CerebroDatePicker} id="date2" name="date2" readOnly />
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="toggle">
										<Field
											as={CerebroCheckbox}
											id="toggle"
											name="toggle"
											error={errors.toggle !== undefined && touched.toggle}
										/>{' '}
										Checkbox
									</CerebroLabel>
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroPill selected={pillSelected} onClick={() => setPillSelected(!pillSelected)}>
										Lorem Ipsum
									</CerebroPill>
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroPill
										disabled
										selected={pillSelected}
										onClick={() => setPillSelected(!pillSelected)}
									>
										Disabled Lorem Ipsum
									</CerebroPill>
								</Box>

								<Box sx={{ marginBottom: 2 }}>
									<CerebroLabel htmlFor="yesNo">
										Will the selling partner be providing any seller financing?
									</CerebroLabel>
									<Field
										as={CerebroYesNo}
										name="yesNo"
										error={errors.yesNo !== undefined && touched.yesNo}
									/>
								</Box>

								<Field
									as={CerebroSelectableIcon}
									name="iconSelected"
									sx={{ marginBottom: 2 }}
									error={errors.iconSelected !== undefined && touched.iconSelected}
									icon={() => <FontAwesomeIcon icon={faAddressBook} size="3x" />}
								>
									Selectable Icon
								</Field>

								<Field
									as={CerebroSelectableIcon}
									wide
									name="wideIconSelected"
									sx={{ marginBottom: 2 }}
									icon={() => <FontAwesomeIcon icon={faAddressBook} size="3x" />}
								>
									Wide Selectable Icon
								</Field>

								<CerebroPrimaryButton type="submit">Save &amp; Continue</CerebroPrimaryButton>

								<Box sx={{ marginTop: 3, marginBottom: 3 }}>
									{Object.entries(errors).map(([field, error]) => (
										<CerebroText key={field} variant="error">
											{error}
										</CerebroText>
									))}
								</Box>

								<Field as={CerebroFileDragAndDrop} name="documents" />

								<CerebroComplexListItem
									sx={{ marginTop: 2 }}
									onEdit={() => {}}
									onDelete={() => {}}
									showDelete={true}
								>
									<Grid container>
										<Grid item xs={4}>
											<CerebroLabel>Original Purpose</CerebroLabel>
											<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
												Unknown / TBD
											</CerebroText>
										</Grid>
										<Grid item xs={4}>
											<CerebroLabel>Monthly Payments</CerebroLabel>
											<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
												{' '}
												--{' '}
											</CerebroText>
										</Grid>
										<Grid item xs={4}>
											<CerebroLabel>Collateral</CerebroLabel>
											<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
												{' '}
												--{' '}
											</CerebroText>
										</Grid>
									</Grid>
								</CerebroComplexListItem>

								<CerebroBrokenBox sx={{ marginTop: 3 }}>
									<CerebroHeading size="h1" component="h3" sx={{ textAlign: 'center' }}>
										Rolling Ownership Percentage 66 %
									</CerebroHeading>
								</CerebroBrokenBox>

								<CerebroMaskedInput value={123456} />

								<Box>
									<Field
										as={CerebroTextarea}
										id="textarea"
										name="textarea"
										rows={4}
										error={touched.input4 && errors.input4 != null}
									/>
								</Box>
							</form>
						);
					}}
				</Formik>
			</CerebroDrawer>
		</Box>
	);
};

type StateAutoCompleteOnTypeProps = CerebroAutoCompleteProps<State, true, false, false> & { value: State[] };

const StateAutoCompleteOnType: React.FC<StateAutoCompleteOnTypeProps> = ({ value, ...props }) => {
	const api = useApi();

	const [inputValue, setInputValue] = React.useState('');

	const searchStates = React.useMemo(
		() =>
			throttle(
				(search: string) =>
					AxiosUtils.getResponseData<State[]>(api.get(CerebroApiEndpoints.Lookups.States(search))),
				200
			),
		[api]
	);

	const statesQuery = useQuery(['states', inputValue], () => searchStates(inputValue), {
		enabled: inputValue != null && inputValue !== '',
	});

	return (
		<CerebroAutoComplete
			{...props}
			multiple
			clearOnEscape
			loading={statesQuery.isLoading}
			options={inputValue !== '' ? statesQuery.data ?? [] : []}
			isOptionEqualToValue={(option: State, value: State) => option.code === value.code}
			getOptionLabel={(state: State) => state.name}
			onInputChange={(event, newInputValue) => {
				setInputValue(newInputValue);
			}}
		/>
	);
};

const ValidationSchema = Yup.object().shape({
	input1: Yup.string().required('Input 1 field is required!'),
	input4: Yup.string().required('Input 4 field is required!'),
	date: Yup.date().min('06/04/1996'),
	dropdown: Yup.mixed().notOneOf([-1]),
	multi: Yup.array().min(1, 'Please select a state'),
	iconSelected: Yup.boolean().isTrue('Icon needs to be selected!'),
	yesNo: Yup.boolean().nullable(true).required(),
	toggle: Yup.boolean().isTrue(),
	iconRadioGroup: Yup.string().nullable(true).required('You must select on of the options in the iconRadioGroup'),
	stateAutoComplete: Yup.array().of(Yup.object()).min(1, 'Please select at least one state'),
	// stateAutoComplete: Yup.object().required('Please select a state'),
});
